import { cn } from "@edusogno/lib/utils";
import { PageHeaderProps } from "@/types";

export default function PageHeading({
  title,
  button,
  subtitle,
  className,
  titleClassName,
  subtitleClassName,
  showButton = true,
}: PageHeaderProps) {
  return (
    <div
      className={cn(
        "max-w-full flex flex-col [&_h2]:text-white md:flex-row gap-4 md:gap-0 w-full justify-between pt-0 md:pt-0 pb-4 md:pb-[min(3cqh, 32px)] ",
        className,
      )}
    >
      <div className="relative flex  w-full flex-col items-start">
        <h2
          className={cn(
            " text-center text-h1 lg:text-h2 font-semibold mb-2",
            titleClassName,
          )}
        >
          {title}
        </h2>

        {subtitle && (
          <p
            className={cn(
              "font-regular text-white text-base",
              subtitleClassName,
            )}
          >
            {subtitle}
          </p>
        )}
      </div>

      {button && showButton && (
        <div className="flex items-center flex-shrink-0">{button}</div>
      )}
    </div>
  );
}
